export function presentationAdd(presentation) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(presentation)
  })
}

export function presentationGetAll(eventId) {
  return fetch(`${process.env.REACT_APP_API_HOST}/event/${eventId}/presentations`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function playsViews(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/{_id}/plays`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}


export function presentationGetOne(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function presentationUpdate(_id, presentation) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(presentation)
  })
}

export function presentationUpdatePrivacy(_id, presentation) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(presentation)
  })
}

export function presentationAddFile(_id, file) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}/addPresentation`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify({
      file
    })
  })
}

export function presentationDeleteFile(_id, file) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}/deletePresentation`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify({
      file
    })
  })
}

export function presentationDeleteVideo(_id, file) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}/deleteVideo`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}



export function presentationDelete(_id) {
  return fetch(`${process.env.REACT_APP_API_HOST}/presentation/${_id}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
}

export function addPresentationAsSpeaker(pptInfo, file) {
  return fetch(`${process.env.REACT_APP_API_HOST}/public-presentation/${pptInfo._id}/addPresentation/${pptInfo.event_id}/${pptInfo.speaker_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      file
    })
  })
}

export function changePresentationPrivacyAsSpeaker(pptInfo, updateObject) {
  return fetch(`${process.env.REACT_APP_API_HOST}/public-presentation/${pptInfo._id}/changePresentationPrivacy/${pptInfo.event_id}/${pptInfo.speaker_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(updateObject)
  })
}
